export class Warning
{
    code: number;
    message: string;
    umss: string;
    messageOrigin: string;
}
